import { render, staticRenderFns } from "./PreferencesEdit.vue?vue&type=template&id=457621d0"
import script from "./PreferencesEdit.vue?vue&type=script&lang=js"
export * from "./PreferencesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports